import userStore from './UserStore'
import accountStore from './AccountStore'
import inventoryLocationStore from './InventoryLocationStore'
import transactionStore from './TransactionStore'
import customerStore from './CustomerStore'
import accountUIStore from './AccountUIStore'
import accountTransactionsUIStore from './AccountTransactionsUIStore'
import historyStore from './HistoryStore'
import accountInventoryLocationsUIStore from './AccountInventoryLocationsUIStore'
import customerTransactionsUIStore from './CustomerTransactionsUIStore'
import loginUIStore from './LoginUIStore'
import customerUIStore from './CustomerUIStore'
import editAccountUIStore from './EditAccountUIStore'
import inventoryLocationTransactionsUIStore from './InventoryLocationTransactionsUIStore'
import logisticPlanStore from './LogisticPlanStore'

const store = {
    userStore,
    accountStore,
    inventoryLocationStore,
    transactionStore,
    customerStore,
    accountUIStore,
    accountTransactionsUIStore,
    historyStore,
    accountInventoryLocationsUIStore,
    customerTransactionsUIStore,
    loginUIStore,
    customerUIStore,
    editAccountUIStore,
    inventoryLocationTransactionsUIStore,
    logisticPlanStore
}

export default store


// WEBPACK FOOTER //
// ./src/stores/index.js